













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class NumberColumnsPicker extends Vue {
  @Prop({ required: true })
  private columns: number[];

  @Prop({ required: true })
  private selectedColumnsNumber: number;

  private emitColumnsNumberChanged(columnsNumber: number) {
    this.$x.emit(EVENTS.ColumnNumberChanged, columnsNumber);
  }
}
